import React from 'react';
import { WinBigBanner } from '../../../../Components/WinBigBanner/WinBigBanner';
import { ProgressOverview } from '../../../../Components/ProgressOverview/ProgressOverview';
import { StatsCards } from '../../../../Components/StatsCards/StatsCards';
import { DateRange } from '../../../Leaderboard/components/DateRange/DateRange';
import { LeaderboardEventSummary } from '../../../../api/leaderboard-events';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import './AdminLeaderboardHeader.scss';

interface AdminLeaderboardHeaderProps {
  summary: LeaderboardEventSummary | null;
}

export const AdminLeaderboardHeader: React.FC<AdminLeaderboardHeaderProps> = ({ summary }) => {
  const { width } = useWindowDimensions();

  return (
    <div className="leaderboard-header leaderboard-header_admin">
      {width > 768 ? (
        <>
          <WinBigBanner />
          <ProgressOverview
            data={
              summary
                ? [
                    {
                      label: 'Total Hours',
                      value: summary.totalHours,
                      max: summary.milestone,
                    },
                    {
                      label: 'Total Reviews',
                      value: summary.reviewsCount,
                      max: summary.reviewMilestone,
                    },
                  ]
                : undefined
            }
          />
          <StatsCards summary={summary} />
        </>
      ) : (
        <>
          <WinBigBanner />
        </>
      )}
      <DateRange startDate={summary?.eventStartDate} endDate={summary?.eventEndDate} />
    </div>
  );
};
